import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaChevronRight,
} from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

function Footer() {
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/services", label: "Services" },
    { to: "/contact", label: "Contact" },
      { to: "/hire-staff", label: "Join Us" },
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/term-and-condition", label: "T&C" },
  ];

  return (
    <footer
      style={{
        background: "#0b1018",
        color: "#fff",
        fontFamily: "'Poppins', sans-serif",
        padding: "60px 0 20px 0",
      }}
    >
      <div className="container">
        <div className="row gy-4">
          
          <div className="col-lg-4 col-md-6">
            {/* <h5
              style={{
                fontSize: "20px",
                fontWeight: "700",
                marginBottom: "20px",
                letterSpacing: "0.5px",
              }}
            >
              ABOUT COMPANY
            </h5> */}

            <p
              style={{
                color: "#d6d6d6",
                lineHeight: "1.8",
                fontSize: "15px",
                maxWidth: "320px",
              }}
            >
          Experience the joy of a truly clean space.
            </p>

            <div className="d-flex gap-3 mt-4">
              <a
                href="/"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "#fff",
                  color: "#0b1018",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
                <FaYoutube/>
              </a>
                 <a
                href="/"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "#fff",
                  color: "#0b1018",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
                <FaFacebook />
              </a>


              <a
                href="/"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "#fff",
                  color: "#0b1018",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
         <FaInstagramSquare />
              </a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <h5
              style={{
                fontSize: "20px",
                fontWeight: "700",
                marginBottom: "20px",
                letterSpacing: "0.5px",
              }}
            >
              ADDRESS
            </h5>

            <p className="mb-3" style={{ color: "#d6d6d6" }}>
              <FaPhoneAlt className="me-2" />
              9559511604
            </p>

            <p className="mb-3" style={{ color: "#d6d6d6" }}>
              <FaEnvelope className="me-2" />
              Sweepydo@gmail.com
            </p>

            <p
              style={{
                color: "#d6d6d6",
                lineHeight: "1.8",
                maxWidth: "330px",
              }}
            >
              <FaMapMarkerAlt className="me-2" />
           {/* Vinayak Vrindavan Tower<br/>Civil Lines,Prayagraj 211001 */}
           64, purani chaupal, Dhaka, Mukharjee nagar,  New delhi 110009
            </p>
          </div>

  
          <div className="col-lg-4 col-md-12">
            <h5
              style={{
                fontSize: "20px",
                fontWeight: "700",
                marginBottom: "20px",
                letterSpacing: "0.5px",
              }}
            >
              QUICK LINKS
            </h5>

            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                onClick={handleScrollTop}
                className="d-flex align-items-center text-decoration-none mb-2"
                style={{
                  color: "#d6d6d6",
                  fontSize: "15px",
                }}
              >
                <FaChevronRight
                  size={10}
                  style={{ marginRight: "10px" }}
                />
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>


        <hr
          style={{
            borderColor: "#2b2f36",
            margin: "40px 0 20px",
          }}
        />

        {/* Bottom footer */}
        <div className="d-flex justify-content-between flex-wrap">
          <p
            style={{
              color: "#d6d6d6",
              marginBottom: "0",
              fontSize: "14px",
            }}
          >
             © 2026 Sweepydo, all rights reserved
          </p>

          <div
            className="d-flex gap-3 mt-2 mt-md-0"
            style={{
              color: "#d6d6d6",
              fontSize: "14px",
            }}
          >
         
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;